import { PencilRuler as icon } from "lucide-react"
import edit from "./experts.edit"
import list from "./experts.list"
import show from "./experts.show"
import { ExpertRecord } from "./experts.types"

const crud = (permissions: Record<string, string[]>) => ({
  name: "experts",
  options: { label: "Experts" },
  show:
    "experts" in permissions && permissions.experts.includes("show")
      ? show
      : undefined,
  list:
    "experts" in permissions && permissions.experts.includes("list")
      ? list
      : undefined,
  edit:
    "experts" in permissions && permissions.experts.includes("edit")
      ? edit
      : undefined,
  icon,

  recordRepresentation: (record: ExpertRecord): string => record.username,
})

export default crud
